import { useEffect } from "react";
import { useLocation } from "react-router-dom";
 
// ✅ Extend the Window interface to include gtag
declare global {
  interface Window {
    gtag?: (command: string, eventName: string, params?: Record<string, any>) => void;
  }
}
 
// Define the shape of your tracking parameters
interface TrackingParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  user_email?: string;
  link_name?: string;
  click_type?: string;
  page_path?: string;
}
 
export default function useUTMTracker() {
  const location = useLocation();
 
useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const trackingParams: TrackingParams = {};
  const paramsList: (keyof TrackingParams)[] = [
    "utm_source", "utm_medium", "utm_campaign", "utm_term",
    "utm_content", "user_email", "link_name", "click_type"
  ];

  paramsList.forEach((param) => {
    const value = urlParams.get(param);
    if (value) localStorage.setItem(param, value);
  });

  paramsList.forEach((param) => {
    const value = localStorage.getItem(param);
    if (value) trackingParams[param] = value || "";
  });

  trackingParams.page_path = location.pathname;

  if (Object.keys(trackingParams).length > 0) {
    const sendEvent = () => {
      if (window.gtag) {
        console.log("📊 Sending utm_capture event", trackingParams);
        window.gtag("event", "utm_capture", {
          ...trackingParams,
          page_location: window.location.href,
        });
      } else {
        console.warn("⚠️ gtag not ready, retrying...");
        setTimeout(sendEvent, 300);
      }
    };
    sendEvent();
  }
}, [location]);
}
